import { render, staticRenderFns } from "./Exclusives.vue?vue&type=template&id=27f7fec8&scoped=true&"
import script from "./Exclusives.vue?vue&type=script&lang=js&"
export * from "./Exclusives.vue?vue&type=script&lang=js&"
import style1 from "./Exclusives.vue?vue&type=style&index=1&id=27f7fec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f7fec8",
  null
  
)

export default component.exports